import { render, staticRenderFns } from "./CampusSelectbox.vue?vue&type=template&id=6255c558"
import script from "./CampusSelectbox.vue?vue&type=script&lang=js"
export * from "./CampusSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports